import { CUSTOM_ELEMENTS_SCHEMA, Component, Input } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { TranslatePipe } from '@app/shared/pipes';

@Component({
  selector: 'app-clinical-alliance-badge',
  templateUrl: './clinical-alliance-badge.component.html',
  styleUrls: ['./clinical-alliance-badge.component.scss'],
  imports: [UpperCasePipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ClinicalAllianceBadgeComponent {
  @Input() displayHeader: boolean;
}
